export default __webpack_public_path__ + "static/media/lobby_with_tables_preview.13fe485f.png";